import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { ThreadRepositoryState } from './types';
import { RootState } from '../types';


export const state: ThreadRepositoryState = {
    threadRepository: {},
};

const namespaced: boolean = true;

export const threadRepository: Module<ThreadRepositoryState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};

